import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetModuleResultsByGasQuery,
  usePublicGetModuleResultsByGasQuery,
  useGetModuleHistoryQuery,
  usePublicGetModuleHistoryQuery,
  useGetSubmoduleDefaultsQuery,
  usePublicGetSubmoduleDefaultsQuery,
  useGetModuleTypesQuery,
  usePublicGetModuleTypesQuery,
  useGetDefaultCountryQuery,
  usePublicGetDefaultCountryQuery,
  useGetModuleByIdQuery,
  usePublicGetModuleByIdQuery
} from '../features/other/createGenericOperationsApi';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting module results by gas based on the current route.
 */
export const useContextAwareGetModuleResultsByGas = createContextAwareHook(
  useGetModuleResultsByGasQuery,
  usePublicGetModuleResultsByGasQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting module history based on the current route.
 */
export const useContextAwareGetModuleHistory = createContextAwareHook(
  useGetModuleHistoryQuery,
  usePublicGetModuleHistoryQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting submodule defaults based on the current route.
 */
export const useContextAwareGetSubmoduleDefaults = createContextAwareHook(
  useGetSubmoduleDefaultsQuery,
  usePublicGetSubmoduleDefaultsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting module types based on the current route.
 */
export const useContextAwareGetModuleTypes = createContextAwareHook(
  useGetModuleTypesQuery,
  usePublicGetModuleTypesQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting default country based on the current route.
 */
export const useContextAwareGetDefaultCountry = createContextAwareHook(
  useGetDefaultCountryQuery,
  usePublicGetDefaultCountryQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting a module by ID based on the current route.
 */
export const useContextAwareGetModuleById = createContextAwareHook(
  useGetModuleByIdQuery,
  usePublicGetModuleByIdQuery
);

// Re-export mutation hooks from genericOperationsApiSlice
export {
  useUpdateModuleNotesMutation,
  useCreateModuleNotesMutation,
  useDeleteModuleNotesMutation,
} from '../features/other/genericOperationsApiSlice'; 